export function stripMarkdown(text: string) {
  if (!text) {
    return '';
  }

  const withoutHtml = text.replace(/<[^>]*>/g, '');

  const withoutMarkdown = withoutHtml
    .replace(/!\[.*?\]\(.*?\)/g, '')
    .replace(/\[.*?\]\(.*?\)/g, '')
    .replace(/[*_~`>#-]/g, '')
    .replace(/^\s*\n/gm, '')
    .replace(/\n{2,}/g, '\n');

  return withoutMarkdown.trim();
}
